// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Board.css')));

var component = ReasonReact.statelessComponent("Card");

function make(value, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      if (value !== 0) {
        return React.createElement("div", {
                    className: "card card_number_" + (String(value) + "")
                  }, "" + (String(value) + ""));
      } else {
        return React.createElement("div", {
                    className: "card"
                  });
      }
    });
  return newrecord;
}

var Card = /* module */[
  /* component */component,
  /* make */make
];

var component$1 = ReasonReact.statelessComponent("Board");

function make$1(board, _) {
  var newrecord = component$1.slice();
  newrecord[/* render */9] = (function () {
      var renderCells = function (row) {
        return $$Array.of_list(List.map((function (value) {
                          return React.createElement("div", {
                                      className: "cell"
                                    }, ReasonReact.element(/* None */0, /* None */0, make(value, /* array */[])));
                        }), row));
      };
      var renderRows = $$Array.of_list(List.map((function (row) {
                  return React.createElement("div", {
                              className: "row"
                            }, renderCells(row));
                }), board));
      return React.createElement("div", {
                  className: "game-area board"
                }, renderRows);
    });
  return newrecord;
}

exports.Card      = Card;
exports.component = component$1;
exports.make      = make$1;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Board.re
// module id = 31
// module chunks = 0